import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';

export default function updateContacts(
	rb: RequestBuilder,
	clientContacts: boolean = false,
	entity: string,
	extraParams: object | undefined,
	multiSelect: MultiSelect
) {
	const opts = {
		customerId: Tools.AppService.getCustomerId(),
		filters: rb,
		extraParams,
		clientContacts,
		entity,
		multiSelect
	};
	return openModal('MultiUpdateContact', opts);
}
